import { Typography } from '@mui/material';

const Title = ({ name }: { name: string }) => (
  <Typography variant="body1" fontWeight="bold" sx={{ my: 2.5 }}>
    {name}
  </Typography>
);

export default Title;
